// extracted by mini-css-extract-plugin
export default {"item":"dragAndRearrange_item__2JHD9","dragging":"dragAndRearrange_dragging__3A8-O"};